import { FIELD_ORDER, FIELD_LABELS, OPTIONAL_FIELDS, fieldOptions } from "@/lib/orderCatalog";

export const chip = (on) => `rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-300 ${on ? "border-white bg-white text-black" : "border-white/15 text-zinc-200 hover:border-white/40"}`;
const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const specLines = (entry, specs) => FIELD_ORDER
  .filter((k) => k !== "size" && fieldOptions(entry, k, specs) && specs?.[k])
  .map((k) => [FIELD_LABELS[k], specs[k]]);

export const OrderSpecFields = ({ entry, specs, onPick }) => (
  <div data-testid="order-spec-fields" className="space-y-4">
    {FIELD_ORDER.map((field) => {
      const opts = fieldOptions(entry, field, specs);
      if (!opts?.length) return null;
      const optional = OPTIONAL_FIELDS.includes(field) && opts.length > 1;
      return (
        <div key={field} data-testid={`order-spec-${field}`}>
          <span className="mb-1.5 block text-xs text-zinc-400">{FIELD_LABELS[field]}{optional ? " (opcional)" : ""}</span>
          <div className="flex flex-wrap gap-2">
            {opts.map((o) => (
              <button type="button" key={o} data-testid={`order-spec-${field}-${slug(o)}`} aria-pressed={specs[field] === o}
                onClick={() => onPick(field, optional && specs[field] === o ? "" : o)} className={chip(specs[field] === o)}>{o}</button>
            ))}
          </div>
        </div>
      );
    })}
  </div>
);

export const OrderSummary = ({ title, lines }) => (
  <div data-testid="order-summary" className="rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3">
    <p className="text-xs uppercase tracking-[0.14em] text-zinc-400">Resumo do pedido</p>
    <p data-testid="order-summary-title" className="mt-1 font-semibold text-white">{title}</p>
    {lines.length > 0 && <p data-testid="order-summary-options" className="mt-1 text-sm text-zinc-300">{lines.map(([, v]) => v).join(" · ")}</p>}
  </div>
);
